module.exports = __webpack_public_path__ + "static/media/brianPina.17df404c.jpg";